// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PartnerSignup.css - Modern Login-like UI Styling */

/* Main signup section background */
.signup {
    background-color: #f8f9fa;
    min-height: 100vh;
    font-family: 'Poppins', sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Partner signup container */
.box-signin-partner {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    max-width: 50%;
    width: 100%;
    margin: 0 auto;
    border: none;
}

/* Title styling */
.box-signin-partner h1 {
    color: #333333;
    font-weight: 600;
    font-size: 28px;
    margin-bottom: 30px;
    font-family: 'Poppins', sans-serif;
}

/* Profile image container */
.profileImageUpdateMultiPartner {
    border: 2px solid #e0e0e0 !important;
    transition: border-color 0.3s ease;
    width: 30%;
}

.profileImageUpdateMultiPartner:hover {
    border-color: #007bff !important;
}

.profileImageLens {
    background-color: #007bff !important;
    bottom: -5px !important;
    right: 5px !important;
    width: 30px;
    height: 30px;
    border: 2px solid #ffffff;
}

.profileInput {
    cursor: pointer;
    opacity: 0;
    z-index: 10;
}

.uploadIcon {
    color: #666666;
    z-index: 5;
}

/* Modern input styling to match login UI */
.box-signin-partner input[type="text"],
.box-signin-partner input[type="email"],
.box-signin-partner input[type="password"],
.box-signin-partner input[type="password_confirm"] {
    border: 2px solid #f1f3f4;
    border-radius: 8px;
    padding: 16px 20px;
    font-size: 16px;
    color: #333333;
    font-family: 'Poppins', sans-serif;
    transition: all 0.3s ease;
    width: 100%;
    box-sizing: border-box;
}

.box-signin-partner input[type="text"]:focus,
.box-signin-partner input[type="email"]:focus,
.box-signin-partner input[type="password"]:focus {
    background: #e8f0fe;
    outline: none;
    box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
}

.box-signin-partner input::placeholder {
    color: #5f6368;
    font-size: 16px;
}

/* Input field labels */
.input-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #202124;
    font-size: 14px;
}

/* Gender radio buttons */
.partnerLabel {
    font-size: 14px;
    color: #555555;
    font-weight: 400;
    cursor: pointer;
    margin-right: 15px;
}

.partnerLabel input[type="radio"] {
    margin-right: 8px;
    accent-color: #007bff;
}

/* Phone input styling */
.PhoneInputInput {
    border: none !important;
    border-bottom: 2px solid #e0e0e0 !important;
    background: transparent !important;
    padding: 12px 0 !important;
    font-size: 16px !important;
    color: #333333 !important;
    font-family: 'Poppins', sans-serif !important;
}

.PhoneInputInput:focus {
    border-bottom-color: #007bff !important;
    outline: none !important;
    box-shadow: none !important;
}

.PhoneInputCountry {
    border: none !important;
    border-bottom: 2px solid #e0e0e0 !important;
    background: transparent !important;
    padding: 12px 8px 12px 0 !important;
}

/* Country, State, City select styling */
.custom-country select,
.custom-country .country-input {
    border: none !important;
    /* border-bottom: 2px solid #e0e0e0 !important; */
    background: transparent !important;
    padding: 12px 0 !important;
    font-size: 16px !important;
    color: #333333 !important;
    font-family: 'Poppins', sans-serif !important;
}

.custom-country select:focus,
.custom-country .country-input:focus {
    border-bottom-color: #007bff !important;
    outline: none !important;
    box-shadow: none !important;
}

/* Password eye button */
.eyeButton {
    background: transparent;
    border: none;
    padding: 12px 8px;
    cursor: pointer;
    color: #666666;
    transition: color 0.3s ease;
}

.eyeButton:hover {
    color: #007bff;
}

/* Submit button */
.update-button,
.button {
    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
    color: #ffffff !important;
    border: none;
    border-radius: 8px;
    padding: 14px 20px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 10px rgba(0, 123, 255, 0.3);
}

.update-button:hover,
.button:hover {
    background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 123, 255, 0.4);
}

/* Error messages */
.signin-error {
    color: #dc3545;
    font-size: 12px;
    margin-top: 5px;
    font-weight: 400;
}

/* Login link */
.accountsign {
    color: #666666;
    font-size: 14px;
    margin-top: 20px;
}

.accountsign span {
    color: #007bff;
    font-weight: 600;
    text-decoration: none;
    transition: color 0.3s ease;
}

.accountsign span:hover {
    color: #0056b3;
    text-decoration: underline;
}

/* Theme colors */
.theme-text-color {
    color: #333333 !important;
}

.theme-bg-color-secondary {
    background-color: #007bff;
}

.theme-border-color {
    border-color: #e0e0e0 !important;
}

/* Responsive design */
@media (max-width: 768px) {
    .box-signin-partner {
        margin: 20px;
        padding: 30px 20px;
    }

    .box-signin-partner h1 {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .partnerLabel {
        display: block;
        margin-bottom: 10px;
    }
}

/* Loading state */
.update-button:disabled {
    background: #6c757d;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* Focus states for accessibility */
.box-signin-partner input:focus,
.box-signin-partner select:focus,
.box-signin-partner button:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/Signup/PartnerSignup.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD,mCAAmC;AACnC;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,6BAA6B;AAC7B;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,cAAc;IACd,WAAW;IACX,cAAc;IACd,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA,4BAA4B;AAC5B;IACI,oCAAoC;IACpC,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA,2CAA2C;AAC3C;;;;IAII,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kCAAkC;IAClC,yBAAyB;IACzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;;IAGI,mBAAmB;IACnB,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,kCAAkC;IAClC,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,uCAAuC;IACvC,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA,wCAAwC;AACxC;;IAEI,uBAAuB;IACvB,iDAAiD;IACjD,kCAAkC;IAClC,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;;IAEI,uCAAuC;IACvC,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;;IAEI,6DAA6D;IAC7D,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;;IAEI,6DAA6D;IAC7D,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA,mBAAmB;AACnB;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA,sBAAsB;AACtB;IACI;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;;;IAGI,0BAA0B;IAC1B,mBAAmB;AACvB","sourcesContent":["/* PartnerSignup.css - Modern Login-like UI Styling */\n\n/* Main signup section background */\n.signup {\n    background-color: #f8f9fa;\n    min-height: 100vh;\n    font-family: 'Poppins', sans-serif;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Partner signup container */\n.box-signin-partner {\n    background: #ffffff;\n    border-radius: 16px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n    max-width: 50%;\n    width: 100%;\n    margin: 0 auto;\n    border: none;\n}\n\n/* Title styling */\n.box-signin-partner h1 {\n    color: #333333;\n    font-weight: 600;\n    font-size: 28px;\n    margin-bottom: 30px;\n    font-family: 'Poppins', sans-serif;\n}\n\n/* Profile image container */\n.profileImageUpdateMultiPartner {\n    border: 2px solid #e0e0e0 !important;\n    transition: border-color 0.3s ease;\n    width: 30%;\n}\n\n.profileImageUpdateMultiPartner:hover {\n    border-color: #007bff !important;\n}\n\n.profileImageLens {\n    background-color: #007bff !important;\n    bottom: -5px !important;\n    right: 5px !important;\n    width: 30px;\n    height: 30px;\n    border: 2px solid #ffffff;\n}\n\n.profileInput {\n    cursor: pointer;\n    opacity: 0;\n    z-index: 10;\n}\n\n.uploadIcon {\n    color: #666666;\n    z-index: 5;\n}\n\n/* Modern input styling to match login UI */\n.box-signin-partner input[type=\"text\"],\n.box-signin-partner input[type=\"email\"],\n.box-signin-partner input[type=\"password\"],\n.box-signin-partner input[type=\"password_confirm\"] {\n    border: 2px solid #f1f3f4;\n    border-radius: 8px;\n    padding: 16px 20px;\n    font-size: 16px;\n    color: #333333;\n    font-family: 'Poppins', sans-serif;\n    transition: all 0.3s ease;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.box-signin-partner input[type=\"text\"]:focus,\n.box-signin-partner input[type=\"email\"]:focus,\n.box-signin-partner input[type=\"password\"]:focus {\n    background: #e8f0fe;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);\n}\n\n.box-signin-partner input::placeholder {\n    color: #5f6368;\n    font-size: 16px;\n}\n\n/* Input field labels */\n.input-label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 500;\n    color: #202124;\n    font-size: 14px;\n}\n\n/* Gender radio buttons */\n.partnerLabel {\n    font-size: 14px;\n    color: #555555;\n    font-weight: 400;\n    cursor: pointer;\n    margin-right: 15px;\n}\n\n.partnerLabel input[type=\"radio\"] {\n    margin-right: 8px;\n    accent-color: #007bff;\n}\n\n/* Phone input styling */\n.PhoneInputInput {\n    border: none !important;\n    border-bottom: 2px solid #e0e0e0 !important;\n    background: transparent !important;\n    padding: 12px 0 !important;\n    font-size: 16px !important;\n    color: #333333 !important;\n    font-family: 'Poppins', sans-serif !important;\n}\n\n.PhoneInputInput:focus {\n    border-bottom-color: #007bff !important;\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n.PhoneInputCountry {\n    border: none !important;\n    border-bottom: 2px solid #e0e0e0 !important;\n    background: transparent !important;\n    padding: 12px 8px 12px 0 !important;\n}\n\n/* Country, State, City select styling */\n.custom-country select,\n.custom-country .country-input {\n    border: none !important;\n    /* border-bottom: 2px solid #e0e0e0 !important; */\n    background: transparent !important;\n    padding: 12px 0 !important;\n    font-size: 16px !important;\n    color: #333333 !important;\n    font-family: 'Poppins', sans-serif !important;\n}\n\n.custom-country select:focus,\n.custom-country .country-input:focus {\n    border-bottom-color: #007bff !important;\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n/* Password eye button */\n.eyeButton {\n    background: transparent;\n    border: none;\n    padding: 12px 8px;\n    cursor: pointer;\n    color: #666666;\n    transition: color 0.3s ease;\n}\n\n.eyeButton:hover {\n    color: #007bff;\n}\n\n/* Submit button */\n.update-button,\n.button {\n    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n    color: #ffffff !important;\n    border: none;\n    border-radius: 8px;\n    padding: 14px 20px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    box-shadow: 0 2px 10px rgba(0, 123, 255, 0.3);\n}\n\n.update-button:hover,\n.button:hover {\n    background: linear-gradient(135deg, #0056b3 0%, #004085 100%);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(0, 123, 255, 0.4);\n}\n\n/* Error messages */\n.signin-error {\n    color: #dc3545;\n    font-size: 12px;\n    margin-top: 5px;\n    font-weight: 400;\n}\n\n/* Login link */\n.accountsign {\n    color: #666666;\n    font-size: 14px;\n    margin-top: 20px;\n}\n\n.accountsign span {\n    color: #007bff;\n    font-weight: 600;\n    text-decoration: none;\n    transition: color 0.3s ease;\n}\n\n.accountsign span:hover {\n    color: #0056b3;\n    text-decoration: underline;\n}\n\n/* Theme colors */\n.theme-text-color {\n    color: #333333 !important;\n}\n\n.theme-bg-color-secondary {\n    background-color: #007bff;\n}\n\n.theme-border-color {\n    border-color: #e0e0e0 !important;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n    .box-signin-partner {\n        margin: 20px;\n        padding: 30px 20px;\n    }\n\n    .box-signin-partner h1 {\n        font-size: 24px;\n        margin-bottom: 20px;\n    }\n\n    .partnerLabel {\n        display: block;\n        margin-bottom: 10px;\n    }\n}\n\n/* Loading state */\n.update-button:disabled {\n    background: #6c757d;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n/* Focus states for accessibility */\n.box-signin-partner input:focus,\n.box-signin-partner select:focus,\n.box-signin-partner button:focus {\n    outline: 2px solid #007bff;\n    outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
